import { KeyofRoom } from "@pages/Assets/RoomProvisioning/const";
import { Room } from "@services/rooms/types";
import { getErrorFromLocationFields } from "./validation";
import { getAllRequiredFields as getLocationAllRequiredFields } from "@common/utils/locations/validation";

export const alwaysRequiredFields: KeyofRoom[] = [
  "name",
  "details.roomType",
  "schedulingOption",
];

export const getLocationRequiredFields = (room?: Room) => {
  return room?.location?.id || room === undefined
    ? []
    : getErrorFromLocationFields(getLocationAllRequiredFields(room.location));
};

export const getAllRequiredFields = (
  room?: Room,
  includeLocationFields: boolean = false
) =>
  [
    alwaysRequiredFields,
    includeLocationFields ? getLocationRequiredFields(room) : [],
  ].flat();

export const isRequired = (property: KeyofRoom, room: Room) =>
  getAllRequiredFields(room).includes(property);
